<template>
  <div v-if="open && getDoctors && clinic" :class="style.widgetMainBlock">
    <section :class="getClassTransition()">
      <button
        v-if="!webVersion"
        :class="style.closeWidget"
        @click="open = false"
      />
      <div
        :id="open ? 'widgetMain' : ''"
        :style="getAdditionalStyles()"
        :class="getClassMainWidget()"
      >
        <div style="height: 100vh">
          <div
            v-if="selectedStage != 1 || consultation"
            @click="stepBack()"
            :class="style.stepBack"
          />
          <HeaderWidget />
          <NavWidget />
          <CustomerChoice v-if="!appointment && !consultation" />
          <AppointmentSuccess v-if="appointment && !consultation" />
          <ConsultationSuccess v-else-if="appointment && consultation" />
          <ConsultationForm v-else-if="consultation" />
          <ChoseService
            v-else-if="selectedStage == 1 && navWidget == 'УСЛУГИ'"
          />
          <ChoseDoctors
            v-else-if="
              selectedStage == 1 ||
              (selectedStage == 2 && navWidget == 'УСЛУГИ')
            "
          />
          <ChoseService v-else-if="selectedStage == 2" />
          <CalendareWidget v-else-if="selectedStage == 3" />
          <ContactForm v-else-if="selectedStage == 4" />
          <footer v-if="selectedStage == 1">
            <img :src="'https://' + DOMAIN + '/api/img?name=footer.svg'" />
          </footer>
        </div>
      </div>
    </section>
    <div v-if="!auth && open" :class="getClassbackgroundWidget()" />
  </div>
  <OpenWidgetButton
    v-model="open"
    v-else-if="getDoctors.length != 0 && JSON.stringify(clinic) != '{}'"
  />
</template>
<script lang="ts">
import style from "./StyleWidget.module.scss";
import $ from "jquery";
import PhoneInput from "../elements/phoneInput/PhoneInput.vue";
import OpenWidgetButton from "./components/OpenWidgetButton.vue";
import HeaderWidget from "./components/HeaderWidget.vue";
import NavWidget from "./components/NavWidget.vue";
import CustomerChoice from "./components/CustomerChoice.vue";
import AppointmentSuccess from "./components/AppointmentSuccess.vue";
import ConsultationSuccess from "./components/ConsultationSuccess.vue";
import ConsultationForm from "./components/ConsultationForm.vue";
import ChoseService from "./components/ChoseService.vue";
import ChoseDoctors from "./components/ChoseDoctors.vue";
import CalendareWidget from "./components/CalendareWidget.vue";
import ContactForm from "./components/ContactForm.vue";
import {doctor} from "@/page/onlineAppointment/doctors/DoctorsType";
import {defineComponent} from "vue";
import {API} from "@/api/generated";

window.$ = $; // это не удалять
export default defineComponent({
  name: "WidgetComponent",
  created() {
    if (this.$route?.query?.id) {
      const routeId = this.$route.query.id;
      this.key = Array.isArray(routeId) ? routeId[0] || this.user._id : routeId;
      this.webVersion = true;
      this.open = true;
    }
  },
  components: {
    PhoneInput,
    OpenWidgetButton,
    HeaderWidget,
    NavWidget,
    CustomerChoice,
    AppointmentSuccess,
    ConsultationSuccess,
    ChoseDoctors,
    ConsultationForm,
    ChoseService,
    CalendareWidget,
    ContactForm
  },
  data() {
    return {
      webVersion: false,
      innerWidth: window.innerWidth,
      style,
      key: "aredfroplgtfrmg3265",
      auth: false,
      open: false,
      specializationSelected: "",
      serviceSelected: "",
      DOMAIN: "readds.ru"
    };
  },
  async mounted() {
    this.DOMAIN = import.meta.env.VITE_DOMAIN;
    const {hostname, href} = window.location;
    if (!this.webVersion) {
      this.auth =
        hostname == import.meta.env.VITE_DOMAIN || hostname == "localhost";
      if (
        href.indexOf("quiz") > 0 &&
        this.$route.params.id &&
        href.indexOf("quiz/setting") == -1
      ) {
        const quiz = await API.getQuizItem({
          query: {id: String(this.$route.params.id)}
        });
        if (quiz && typeof quiz.userId == "string") {
          this.key = quiz.userId;
          this.auth = false;
        }
      }
    }
    if (this.auth) {
      var input = document.querySelector(
        'input[name="photoLogo"]'
      ) as HTMLInputElement;
      if (input) {
        input.oninput = this.loadData;
      }
      this.watchPathUpdate();
    }
  },
  methods: {
    getAdditionalStyles() {
      if (this.webVersion) {
        return;
      }
      return {borderLeft: this.auth ? "solid 1px #EDEDED" : "none"};
    },
    getClassbackgroundWidget() {
      let arr = [style.backgroundWidget];
      if (this.webVersion) {
        arr.push(style.images);
      } else {
        arr.push(style.darkening);
      }
      return arr.join(" ");
    },
    getClassMainWidget() {
      let classList = [this.style.widget];
      if (this.webVersion) {
        classList.push(this.style.webVersion);
      }
      return classList.join(" ");
    },
    getClassTransition() {
      if (this.auth || this.webVersion) {
        return "";
      }
      return innerWidth < 770
        ? style.transitionMobile
        : style.transitionDesktop;
    },
    watchPathUpdate() {
      if (this.auth == false) {
        return;
      }
      let oldHref = document.location.href;
      const body = document.querySelector("body");
      const observer = new MutationObserver(() => {
        if (oldHref !== document.location.href) {
          oldHref = document.location.href;
          var input = document.querySelector(
            'input[name="photoLogo"]'
          ) as HTMLInputElement;
          if (input) {
            input.oninput = this.loadData;
          }
        }
      });
      if (body) {
        observer.observe(body, {childList: true, subtree: true});
      }
    },
    stepBack() {
      if (this.appointment || this.consultation) {
        this.resetSettings();
        return;
      }
      if (this.selectedStage == 1) {
        return;
      }
      this.setSelectedStage(this.selectedStage - 2);
    },
    resetSettings() {
      this.$widgetStore.reset();
    },
    setSelectedStage(key: number): void {
      if (key + 1 == this.selectedStage) {
        return;
      }
      this.$widgetStore.updateConsultation(false);
      if (key == 0) {
        this.chose.DoctorName = "";
        this.chose.DoctorService = "";
      }
      if (key <= 1) {
        if (this.navWidget == "УСЛУГИ") {
          this.chose.DoctorName = "";
        } else {
          this.chose.DoctorService = "";
        }
      }
      if (key == 0) {
        if (this.navWidget == "УСЛУГИ") {
          this.$widgetStore.setStages([this.hints["service"]]);
        } else {
          this.$widgetStore.setStages([this.hints["doctor"]]);
        }
      } else {
        this.$widgetStore.setStages(this.stages.slice(0, key));
      }
      this.$widgetStore.setSelectedStage(key + 1);
    },
    loadData() {
      this.$widgetStore.getWidgetData(this.auth);
    },
    setChoiceDoctor(doctor: doctor) {
      this.chose.DoctorName = doctor.name;
      this.chose.doctor = doctor;
      this.$widgetStore.setSelectedStage(this.selectedStage + 1);
    },
    changeSelectedStage(data: number): void {
      if (data < 2) {
        if (this.navWidget == "УСЛУГИ") {
          this.$widgetStore.setStages([this.hints["service"]]);
        } else {
          this.$widgetStore.setStages([this.hints["doctor"]]);
        }
      }
      if (this.chose.DoctorName) {
        let index = this.navWidget == "УСЛУГИ" ? 1 : 0;
        this.stages[index] = [String(index + 1), "Врач", this.chose.DoctorName];
        if (index == 1) {
          this.stages[index + 1] = [...this.hints["dateTime"]];
        } else {
          this.stages[index + 1] = [...this.hints["service"]];
          this.stages[index + 1] = ["1", "Выберете услугу"];
          if (this.stages.length == 3) {
            this.stages[index + 1][2] = this.chose.DoctorService;
          }
          if (this.stages.length == 2) {
            this.stages[index + 1][1] = "Выберете услугу";
          }
        }
        this.stages[index + 1][0] = String(index + 2);
      }
      if (this.chose.DoctorService) {
        let index = this.navWidget == "УСЛУГИ" ? 0 : 1;
        this.stages[index] = [
          String(index + 1),
          "Услуга",
          this.chose.DoctorService
        ];
        if (index == 1) {
          this.stages[index + 1] = [...this.hints["dateTime"]];
        } else {
          this.stages[index + 1] = ["1", "Выберете врача"];
          if (this.stages.length == 3) {
            this.stages[index + 1][2] = this.chose.DoctorName;
          }
          if (this.stages.length == 2) {
            this.stages[index + 1][1] = "Выберете врача";
          }
        }
        this.stages[index + 1][0] = String(index + 2);
      }
    }
  },
  computed: {
    user() {
      return this.$userStore.getUser;
    },
    consultation() {
      return this.$widgetStore.getConsultation;
    },
    appointment() {
      return this.$widgetStore.getAppointment;
    },
    getDoctors(): doctor[] {
      return this.$widgetStore.getDoctors;
    },
    clinic() {
      return this.$widgetStore.clinic;
    },
    chose() {
      return this.$widgetStore.getChose;
    },
    selectedStage() {
      return this.$widgetStore.getSelectedStage;
    },
    navWidget() {
      return this.$widgetStore.getNavWidget;
    },
    stages() {
      return this.$widgetStore.getStages;
    },
    hints() {
      return this.$widgetStore.getHints;
    }
  },
  watch: {
    "user._id": function (data) {
      this.key = data;
    },
    key() {
      this.$widgetStore.setKey(this.key);
      this.loadData();
    },
    consultation(data) {
      if (data) {
        const lenStages = this.stages.length;
        this.stages[lenStages - 1] = [...this.hints["shape"]];
        this.stages[lenStages - 1][0] = String(lenStages);
      } else {
        this.changeSelectedStage(this.selectedStage);
      }
    },
    selectedStage(data) {
      this.changeSelectedStage(data);
    },
    navWidget() {
      if (this.navWidget == "УСЛУГИ") {
        this.$widgetStore.setStages([this.hints["service"]]);
      } else {
        this.$widgetStore.setStages([this.hints["doctor"]]);
      }
      this.resetSettings();
    },
    open(data) {
      if (this.auth == true) {
        return;
      }
      if (data == true) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    }
  }
});
</script>
